import APIURL from "../components/Constant";

export const QUESTION_ACTION_ENUM = {
  APPROVE: "approve",
  REJECT: "reject",
};


export const BASE_URL =
  process.env.REACT_APP_BASE_URL || `https://avionica.csdevhub.com`;
  // process.env.REACT_APP_BASE_URL || `https://uat.avioflai.com`;

export const IMAGE_URL =  `${APIURL}/user-service/static/admin/images/`;

export const ASSETS_URL = "https://d3p4qddo22chul.cloudfront.net/admin-assets/";

export const API_BASE_URL = "https://avionica.csdevhub.com/ingestion-backend/api";
